<template>
  <v-container>
    <v-layout row class="mt-3 mb-1">
      <v-flex xs12 md10 lg8 offset-md1 offset-lg2 class="pa-3 white" elevation-15>
        <v-layout>
          <v-flex xs11>
            <b><v-text-field
              name="search"
              :label="$t('search_blacklist')"
              :rules="[() => search.length > 2 || $t('enter_at_least_3_characters')]"
              single-line
              v-model="search"
              full-width
              :hide-details="true"
              prepend-icon="search"
              @keypress.enter="doSearch"
              ref="focus"
            ></v-text-field></b>
          </v-flex>
          <v-flex xs1 class="mt-1">
            <v-btn icon v-if="!loading && search.length > 2" @click="doSearch"><v-icon>forward</v-icon></v-btn>
            <v-progress-circular indeterminate class="primary--text" v-if="loading"></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-container class="text-xs-center grey--text lighten-3">
      {{ $t("search_tips") }}
    </v-container>
    <!--v-container class="mt-5 text-xs-center primary--text" v-if="!searchPerformed">
      <p><img src="static/img/sharing.png"/></p>
      <h5><strong>{{ $t("sharing_is_caring")|upper }}</strong></h5>
      <v-layout>
        <v-flex xs12 md8 lg6 offset-md2 offset-lg3>
          {{ $t("sharing_is_caring_text") }}
        </v-flex>
      </v-layout>
    </v-container-->

    <!-- <v-layout row>
      <v-flex xs12 class="text-xs-center">
        <v-btn
          :loading="loading"
          @click.native="doSearch"
          :disabled="loading"
          class="blue-grey white--text"
        >
          Search
          <v-icon right>search</v-icon>
        </v-btn>
      </v-flex>
    </v-layout> -->

    <!-- Search results -->
    <v-layout row v-if="searchPerformed && !loading">
      <v-flex xs12 class="text-xs-center" v-if="!items.length">
        <v-container class="text--center">
          {{ $t("no_records_found") }}
        </v-container>
      </v-flex>
      <v-flex xs12 v-else>
        <v-layout class="primary--text my-3">
          <v-flex xs6 class="text-xs-left">
            <h3><strong>{{ $t("matches_found") }}</strong></h3>
          </v-flex>
          <v-flex xs6 class="text-xs-right">
            <strong class="text-xs-right">{{ $t("total") }} {{items.length}}</strong>
          </v-flex>
        </v-layout>
        <guests-list :guests="items"></guests-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { HTTP } from '../../utils'
  import GuestsList from './GuestsList'

  export default {
    components: {
      GuestsList
    },

    data () {
      return {
        searchPerformed: false,
        loading: false,
        search: '',
        items: []
      }
    },

    created () {
      // this.doSearch()
    },

    mounted () {
      requestAnimationFrame(() => {
        this.$refs.focus.focus()
      })
    },

    methods: {
      doSearch () {
        if (!this.search || this.search.length < 3) {
          this.$notify({
            group: 'app',
            type: 'error',
            text: '<center>' + this.$t('enter_at_least_3_characters') + '</center>',
            duration: 2000
          })
          return
        }
        this.loading = true
        this.searchPerformed = true
        const self = this
        const q = this.search
        const params = { q }
        HTTP.get('guest', { params })
          .then(response => {
            self.items = response.data
            self.loading = false
          })
          .catch(error => {
            console.log(error)
            self.items = []
            self.loading = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Guests/Search.vue